import { $api } from "@/kibi/core/utils/api";
import type { InjectionKey } from "vue";
import type {
  AccountOrganizationDTO,
  LanguageDTO,
} from "../models/account_model";

export interface AccountDataSource {
  listUserOrganizations(): Promise<AccountOrganizationDTO[]>;
  listLanguages(): Promise<LanguageDTO[]>;
}

export const accountDataSourceKey: InjectionKey<AccountDataSource> =
  Symbol("AccountDataSource");

export class AccountDataSourceImpl implements AccountDataSource {
  async listUserOrganizations(): Promise<AccountOrganizationDTO[]> {
    const response = await $api<{
      message: string;
      data: AccountOrganizationDTO[];
    }>("/accounts/user-organizations", {
      method: "GET",
    });
    return response.data;
  }

  async listLanguages(): Promise<LanguageDTO[]> {
    const response = await $api<{
      message: string;
      data: LanguageDTO[];
    }>("/accounts/languages", {
      method: "GET",
    });
    return response.data;
  }
}
